<div
  *ngIf="product"
  class="product"
  [class.product--even]="index !== undefined && index % 2 === 0"
>
  <div class="product-image">
    <img
      [src]="
        product.defaultImageURL ||
        'https://s3.amazonaws.com/Glambox.Catalog.Settings/ProductVariantDefaultImage_0_SML.png'
      "
    />
  </div>
  <div class="product-info">
    <a
      [routerLink]="
        '/products/catalog/product-variant/' + product.productVariantId
      "
      class="data-link"
    >
      {{ product.externalId }}
    </a>
    <span>- {{ product.productVariantName | titlecase }}</span>
    <ng-container *ngIf="product.internalEAN">
      ({{ product.internalEAN }})
    </ng-container>
    <span class="info">
      <ng-container *ngIf="product.categoryId">
        <br />
        <strong>Categoria: </strong>{{ product.categoryExternalIdString }}
        {{ product.category }} -
      </ng-container>
      <ng-container *ngIf="!product.categoryId && !product.subcategoryId">
        <br />
      </ng-container>
      <strong>BrandEquity: </strong>{{ equityLabel(product.brandEquity) }}
    </span>
  </div>
  <div class="extra-info" *ngIf="product.shippingOrderTypeId !== 1">
    <i
      class="pi pi-gift"
      pTooltip="Brinde"
      tooltipPosition="bottom"
      *ngIf="product.shippingOrderTypeId === 4"
    ></i>
    <i
      class="pi pi-shopping-cart"
      pTooltip="Troca"
      tooltipPosition="bottom"
      *ngIf="product.shippingOrderTypeId === 3"
    ></i>
    <i
      class="pi pi-money-bill"
      pTooltip="Incentivo para influencer"
      tooltipPosition="bottom"
      *ngIf="product.shippingOrderTypeId === 5"
    ></i>
    <i
      class="pi pi-book"
      pTooltip="Assinatura"
      tooltipPosition="bottom"
      *ngIf="product.shippingOrderTypeId === 8"
    ></i>
  </div>
</div>
